import React from "react";
import "./style.css";

const BBPS = () => {
  const billCategories = [
    "Electricity",
    "Mobile & DTH",
    "Broadband",
    "Insurance",
    "Water & Gas",
    "Loan Repayments",
  ];

  return (
    <>
      <section className="bbps-banner">
        <div className="bbps-content">
          <p className="bbps-eyebrow">Bharat Bill Payment System</p>
          <h1 className="bbps-title">BBPS Bill Payments</h1>
          <p className="bbps-subtitle">
            One secure platform for fast, reliable everyday bill payments.
          </p>
        </div>
      </section>

      <section className="bbps-intro">
        <p className="bbps-eyebrow">Simple for merchants and customers</p>
        <h2>Connect customers to essential bill payments</h2>
        <p>
          Omeswara BBPS helps businesses collect utility and recurring payments
          through a convenient, trusted experience. Give customers quick
          access to multiple billers while keeping transactions easy to track.
        </p>
      </section>

      <section className="bbps-categories">
        <h2>Supported bill payment categories</h2>
        <div className="bbps-grid">
          {billCategories.map((category) => (
            <div className="bbps-card" key={category}>
              <h3>{category}</h3>
              <p>Fast processing with clear payment confirmation.</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bbps-benefits">
        <h2>Why businesses choose BBPS</h2>
        <div className="bbps-benefit-list">
          <p>Reliable biller connectivity</p>
          <p>Secure transaction processing</p>
          <p>Simple merchant reconciliation</p>
          <p>Responsive customer support</p>
        </div>
      </section>
    </>
  );
};

export default BBPS;
